import { VOUCHER_SET_AVAILABLE_EXAMS, VOUCHER_SET_LOADING_STATUS_EXAMS, VOUCHER_SET_SELECTED_EXAMS, VOUCHER_CLEAR_ALL_DATA, VOUCHER_INACTIVE } from '../types'
import examService from '../../api/exam'
import orderService from '../../api/order'
import notify from '../../api/notification'
import analytics from '../../api/analytics'

const state = {
  examsAvailable: [],
  examsSelected: [],
  voucherStatus: true,
  loadingStatusExam: 'STATUS_INITIAL'
}

const mutations = {
  [VOUCHER_SET_AVAILABLE_EXAMS] (state, exams) {
    state.examsAvailable = exams
  },
  [VOUCHER_SET_LOADING_STATUS_EXAMS] (state, exam) {
    state.loadingStatusExam = exam
  },
  [VOUCHER_SET_SELECTED_EXAMS] (state, exam) {
    state.examsSelected = exam
  },
  [VOUCHER_CLEAR_ALL_DATA] (state) {
    state.examsAvailable = []
    state.examsSelected = []
    state.loadingStatusExam = 'STATUS_INITIAL'
  },
  [VOUCHER_INACTIVE] (state, value) {
    state.voucherStatus = value
  }
}

const getters = {
  availableExamsForVoucher: state => {
    return state.examsAvailable
  },
  getVoucherLoadingExamStatus: state => {
    return state.loadingStatusExam
  },
  getSelectedVoucherExams: state => {
    return state.examsSelected
  },
  isVoucherInactive: state => {
    return state.voucherStatus
  }
}

const actions = {
  setAvailableExamsForVoucher: function ({ commit }) {
    commit(VOUCHER_SET_LOADING_STATUS_EXAMS, 'STATUS_LOADING')
    examService
      .getAvailableExamsForVoucher()
      .then(response => {
        commit(VOUCHER_SET_AVAILABLE_EXAMS, response.data)
        commit(VOUCHER_SET_LOADING_STATUS_EXAMS, 'STATUS_SUCCESS')
      })
      .catch(error => {
        commit(VOUCHER_SET_LOADING_STATUS_EXAMS, 'STATUS_FAILED')
        var payload = error.response.data
        notify({
          title: 'AVISO:',
          message: 'Houve um erro ao carregar os exames disponíveis.',
          action: {
            title: 'TENTAR NOVAMENTE',
            handler: reload
          }
        })
        analyticsErrorXSD(payload.description || payload.message)
      })
  },
  getInactiveVoucher: function ({ commit }) {
    orderService.inactiveVoucher().then(response => {
      commit(VOUCHER_INACTIVE, response.data)
    })
  },
  setSelectedExams: function ({ dispatch, commit }, exam) {
    commit(VOUCHER_SET_SELECTED_EXAMS, exam)
    dispatch('clearExamList')
    let index
    for (let i = exam.length; i > 0; i--) {
      index = i - 1
      dispatch('pushLoadingExam', exam[index].id)
      dispatch('getExamDetails', exam[index].id)
    }
  },
  clearAllVoucherData ({ commit }) {
    commit(VOUCHER_CLEAR_ALL_DATA)
  }
}

let reload = function () {
  window.location.reload()
}

let analyticsErrorXSD = (message) => {
  analytics.pushAnalyticsEvent(
    'ga-event', { 'category': 'Voucher Interlaboratorial', 'action': message }
  )
}

export default { state, mutations, actions, getters }
export { mutations, actions, getters }
